import { useOptimisticCart } from "@/hooks/use-optimistic-cart"
import { useState } from "react"

/**
 * Shared "save the bag, then go" flow for cart CTAs (FinishCartButton,
 * FloatingCartButton): guards against re-entry while a navigation is in
 * flight, flushes pending cart-sync operations, and always runs `after`
 * (navigate, open auth sheet, ...) even if the flush fails.
 *
 * `isBusy` composes the cart-sync `isSyncing` flag with the local
 * navigation guard — identical to the previous inline pattern.
 */
export function useFlushAndGo() {
  const { isSyncing, flush } = useOptimisticCart()
  const [isNavigating, setIsNavigating] = useState(false)

  async function run(after: () => void) {
    if (isNavigating) return
    setIsNavigating(true)
    try {
      await flush()
    } finally {
      setIsNavigating(false)
      after()
    }
  }

  return { isBusy: isSyncing || isNavigating, run }
}
